﻿import { DATE_FORMATS, PROJECT_STATUS } from "@/enums";
import { flattenApprovers } from "@/helpers";
import dayjs from "dayjs";
import { getUserWhoApprovedStep } from "../helpers";

export const getApprovalSteps = (
  projectStatusId,
  flattenApprovalWorkflow,
  usersWhoApprovedSteps,
  historyOfApprovals,
  approvalWorkflowIncludingDeleted
) => {
  if (
    projectStatusId === PROJECT_STATUS.intake.draft.id ||
    projectStatusId === PROJECT_STATUS.intake.onHold.id ||
    projectStatusId === PROJECT_STATUS.intake.canceled.id ||
    projectStatusId === PROJECT_STATUS.intake.inApproval.id
  ) {
    return flattenApprovalWorkflow?.map(({ id, secondaryId: roleId }) => {
      const approvalDate = historyOfApprovals?.find(
        ({ workflowStepId }) => workflowStepId === id
      )?.setAt;

      return {
        id,
        roleId,
        userWhoApproved: getUserWhoApprovedStep(
          usersWhoApprovedSteps,
          historyOfApprovals,
          id
        ),
        formattedDate:
          approvalDate && dayjs(approvalDate).format(DATE_FORMATS.twoDigitYear),
      };
    });
  }

  if (!approvalWorkflowIncludingDeleted?.approvers || !historyOfApprovals)
    return [];

  const flattenHistoricApprovalWorkflow = flattenApprovers(
    approvalWorkflowIncludingDeleted.approvers
  );

  return historyOfApprovals?.map((historyItem) => ({
    id: historyItem.workflowStepId,
    roleId: flattenHistoricApprovalWorkflow?.find(
      (x) => x.id === historyItem.workflowStepId
    )?.secondaryId,
    persistedRoleName: historyItem.approverName,
    userWhoApproved: usersWhoApprovedSteps?.find(
      (x) => x.id === historyItem.setBy
    ),
    formattedDate:
      historyItem.setAt &&
      dayjs(historyItem.setAt).format(DATE_FORMATS.twoDigitYear),
  }));
};
